import React, { useEffect, useState } from 'react';
import { cn } from '../lib/utils'; 
import Marquee from '../components/magicui/marquee';
import { forwardRef, useRef } from "react";
import { AnimatedBeam } from "../components/magicui/animated-beam";
import WordRotate from "../components/magicui/word-rotate";
import ExploreByExam from '../components/ExploreExam';
import Faculties from '../components/FacultyCard';
// import { Course } from '../components/interfaces';
import CourseList from '../components/CourseListHome';
import { BorderBeam } from "../components/magicui/border-beam";
import CollectiveCourseList from '../components/CollectiveCourses';
import { CollectiveCourse } from '../components/interfaces'
import { useAuth } from '../context/AuthContext'; 
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import NotificationsPage from '../components/Notification';
import FloatingWhatsAppButton from '../components/FloatingWhatsappButton';
import Language4Ad from '../components/Ads4Language';
import SocialShareCard from '../components/ShareableSocialLink';
import { RainbowButton } from '../components/magicui/rainbow-button';
import HeroVideoDialog from '../components/magicui/hero-video-dialog';
import WelcomeComponent from '../components/WelcomeTest';
// import DeviceUuidDisplay from '../components/MobileUuid';
// import NAETalentTestResults from '../components/NAETTResult';
import ScienceCoursesApp from '../components/ScienceSection';
import ArtsCoursesApp from '../components/ArtsSection';
import ProblemBasedCoursesApp from '../components/ProblemBasedCourse';
import InteractiveLink from '../components/IntractiveLink';
// import ResponsiveInfiniteCarousel from '../components/HeaderCarousel';
import HindiEnglishCourseCard from '../components/EnglishCourseCard';
import ResponsiveInfiniteCarousel from '../components/HeaderCarousel';
import KaunBanegaKyaContestLink from '../components/KaunBanegaKya';
// import Language4Ad from '../components/4Language';




function WordRotateD() {
  return (
    <WordRotate
      className="text-3xl md:text-5xl font-extrabold text-white dark:text-white"
      words={["Science 12", "A r t s 12", "Class 10"]}
    />
  );
}


interface Course {
  id: number;
  course_name: string;
  description: string;
  course_img: string | null;
  class_for: { name: string }[];
  teacher: { user: { first_name: string; last_name: string } };
  mode: string;
  tags: { name: string }[];
  price: string;
  discount_percentage: string;
}


const Home: React.FC = () => {
  const { isAuthenticated, studentId, studentClass } = useAuth();
  const [courses, setCourses] = useState<Course[]>([]);
  const [savedCourses, setSavedCourses] = useState<Course[]>([]);
  // const [savedCollectiveCourses, setSavedCollectiveCourses] = useState<CollectiveCourse[]>([]);
  
  const [collectiveCourses, setCollectiveCourses] = useState<CollectiveCourse[]>([]);
  const [yourCourses, setYourCourses] = useState<Course[]>([]);
  const [yourCollectiveCourses, setYourCollectiveCourses] = useState<CollectiveCourse[]>([]);
  const API_URL = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchCourses = async () => {
      const cachedCourses = localStorage.getItem('courses');
      const coursesExpiry = localStorage.getItem('coursesExpiry');
      const now = new Date();
  
      if (cachedCourses && coursesExpiry && now < new Date(coursesExpiry)) {
        // If cached data exists and is not expired, use it
        setCourses(JSON.parse(cachedCourses).slice(0, 10));

      } else {
        // Otherwise, fetch from server and cache the result
        try {
          const response = await axios.get(`${API_URL}/courses/courses/`);
          setCourses([...response.data].slice(10));

          
          // Cache the data and set an expiry time (e.g., 1 day)
          localStorage.setItem('courses', JSON.stringify(response.data.reverse()));
          localStorage.setItem('coursesExpiry', new Date(now.getTime() + 10 * 60 * 1000).toISOString());
        } catch (error) {
          console.error('Error fetching courses:', error);
        }
      }
    };

    const fetchCollectiveCourses = async () => {
      const cachedCollectiveCourses = localStorage.getItem('collectiveCourses');
      const collectiveCoursesExpiry = localStorage.getItem('collectiveCoursesExpiry');
      // console.log(cachedCollectiveCourses, collectiveCoursesExpiry)
      const now = new Date();
  
      if (cachedCollectiveCourses && collectiveCoursesExpiry && now < new Date(collectiveCoursesExpiry)) {
        // If cached data exists and is not expired, use it
        setCollectiveCourses(JSON.parse(cachedCollectiveCourses).slice(0, 10));
      } else {
        // Otherwise, fetch from server and cache the result
        try {
          const response = await axios.get(`${API_URL}/courses/collective-courses/`);          
          setCollectiveCourses([...response.data].slice(-10).reverse());
  
          // Cache the data and set an expiry time (e.g., 1 day)
          localStorage.setItem('collectiveCourses', JSON.stringify(response.data.reverse()));
          localStorage.setItem('collectiveCoursesExpiry', new Date(now.getTime() + 10 * 60 * 1000).toISOString());
        } catch (error) {
          console.error('Error fetching collective courses:', error);
        }
      }
    };
  
    fetchCourses();
    fetchCollectiveCourses();

  }, []);

  useEffect(() => {
    

    const fetchYourCourses = async () => {
      const cachedYourCourses = localStorage.getItem(`your${studentId}${studentClass}Courses`);
      const yourCoursesExpiry = localStorage.getItem(`your${studentId}${studentClass}CoursesExpiry`);
      const now = new Date();
  
      if (cachedYourCourses && yourCoursesExpiry && now < new Date(yourCoursesExpiry)) {
        // If cached data exists and is not expired, use it
        setYourCourses(JSON.parse(cachedYourCourses));

      } else {
        // Otherwise, fetch from server and cache the result
        try {
          const response = await axios.get(`${API_URL}/courses/courses/by-class/${studentClass}`);
          
          setYourCourses(response.data);
          
          // Cache the data and set an expiry time (e.g., 1 day)
          localStorage.setItem(`your${studentId}${studentClass}Courses`, JSON.stringify(response.data));
          localStorage.setItem(`your${studentId}${studentClass}CoursesExpiry`, new Date(now.getTime() + 10 * 60 * 1000).toISOString());
        } catch (error) {
          console.error('Error fetching courses:', error);
        }
      }
    };

    
    const fetchYourCollectiveCourses = async () => {
      const cachedYourCollectiveCourses = localStorage.getItem(`your${studentId}${studentClass}CollectiveCourses`);
      const yourCollectiveCoursesExpiry = localStorage.getItem(`your${studentId}${studentClass}CollectiveCoursesExpiry`);
      const now = new Date();
  
      if (cachedYourCollectiveCourses && yourCollectiveCoursesExpiry && now < new Date(yourCollectiveCoursesExpiry)) {
        // If cached data exists and is not expired, use it
        setYourCollectiveCourses(JSON.parse(cachedYourCollectiveCourses));        

      } else {
        // Otherwise, fetch from server and cache the result
        try {
          const response = await axios.get(`${API_URL}/courses/collective-courses/by-class/${studentClass}`);

          setYourCollectiveCourses(response.data);
          
          // Cache the data and set an expiry time (e.g., 1 day)
          localStorage.setItem(`your${studentId}${studentClass}CollectiveCourses`, JSON.stringify(response.data));
          localStorage.setItem(`your${studentId}${studentClass}CollectiveCoursesExpiry`, new Date(now.getTime() + 10 * 60 * 1000).toISOString());
        } catch (error) {
          console.error('Error fetching Collectivecourses:', error);
        }
      }
    };
    
    if(studentId && studentClass){
      fetchYourCourses();
      fetchYourCollectiveCourses();
    }

  }, [studentClass]);
  


  const saveCourse = (course: Course) => {
    setSavedCourses((prevCourses) => [...prevCourses, course]);
  };


  return (
    <div className="overflow-hidden">
      <Helmet>
            <title>NAE COACHING | Home</title>
            <meta name="description" content="Bihar board online and offline coaching for Science, Arts and Matric. Offline Coaching in Thakurganj, Kishanganj (Bihar)." />
      </Helmet>

      <ResponsiveInfiniteCarousel />
      <HindiEnglishCourseCard />
      
      <InteractiveLink />
      <ExploreByExam />
      <ScienceCoursesApp />
      <KaunBanegaKyaContestLink />
      {/* <NAETalentTestResults /> */}
      <ProblemBasedCoursesApp />
      
      <ArtsCoursesApp />

      <div id="naetalenttest" className='flex flex-col justify-center items-center p-2'>
          <WelcomeComponent />
      </div>

      {isAuthenticated ? null : (
        <div className="flex flex-col justify-center items-center">
          <div className="relative flex w-full max-w-5xl p-2 flex-col items-center justify-center overflow-hidden rounded-xl border bg-background md:shadow-xl">
            <span className="pointer-events-none whitespace-pre-wrap bg-gradient-to-b from-black to-gray-300/80 bg-clip-text text-center text-8xl font-bold leading-none text-transparent dark:from-white dark:to-slate-900/10">
              N A E
            </span>
            {/* <BorderBeam size={250} duration={12} delay={9} /> */}
          </div>
          
          <div className="flex flex-col items-center justify-start w-full max-w-5xl p-2 md:p-4 shadow-xl rounded-xl bg-[#52c485]">
            <div className="text-xl md:text-2xl lg:text-3xl font-medium text-center flex flex-col md:flex-row items-center justify-center">
              <span className="text-white text-2xl md:text-4xl font-extrabold mx-3">We are Here</span> for
              <span className="text-white text-2xl md:text-4xl font-extrabold mx-3">Best Results</span> in
              <span className="mx-5"><WordRotateD /></span>
            </div>
            <div className="text-xl md:text-2xl lg:text-3xl font-medium text-center mt-2 md:mt-4">
              <span className="text-white">BSEB Board</span> के लिए <span className="text-white">Expert Guidance!</span>
            </div>
          </div>

          {/* <div className='max-w-4xl m-3 px-4'>
            <div className='w-full p-3 py-5 border-4 border-red-300 shadow-lg shadow-red-800 rounded-2xl text-lg font-bold'>
            <p className='text-lg font-bold text-emerald-700 mb-4'>इन्टॉल और साइन अप कैसे करे </p>
            <div className='flex space-x-4'>
            <Link  to={`/VideoContent/-y1G9Y0GpZU`} className="text-white hover:underline bg-red-500 rounded-xl p-1 mt-4">
            वीडियो  देखें
            </Link>
            <a href='https://www.youtube.com/watch?v=-y1G9Y0GpZU' className="text-white hover:underline bg-red-500 rounded-xl p-1 mt-4">Go to Youtube</a>
            </div>
            </div>
          </div> */}
          {/* <AnimatedBeamDemo /> */}
        </div>
      )}
        
          
          {/* <DeviceUuidDisplay /> */}
          {/* <div className='w-full max-w-4xl p-2 rounded-xl shadow-xl flex justify-center items-center'>          
            <img src="https://naendapi.naecoaching.com/media/images/nae-talent-test-2025.jpg" />
          </div> */}
          {/* <RainbowButton>Get Unlimited Access</RainbowButton> */}
          {/* <Link to={'/N_A_E_Talent_Test'} className='p-2 mt-8 rounded-2xl shadow-2xl w-full sm:w-64 px-6 bg-purple-600 hover:bg-purple-500 hover:border-2 flex flex-col justify-center items-center'>          
          <h1 className='text-white font-bold'> Click for Registration</h1>
          <h1 className='text-white font-semibold'> रजिस्ट्रेशन के लिए क्लिक करें </h1>
            
          </Link> */}
        
        <div className="relative mx-auto w-full max-w-4xl p-4">
          <HeroVideoDialog
            className="block dark:hidden"
            animationStyle="from-center"
            videoSrc="https://www.youtube.com/embed/m49xicAem6E"
            thumbnailSrc="https://img.youtube.com/vi/m49xicAem6E/maxresdefault.jpg"
            thumbnailAlt="Hero Video"
          />
          <HeroVideoDialog
            className="hidden dark:block"
            animationStyle="from-center"
            videoSrc="https://www.youtube.com/embed/m49xicAem6E"
            thumbnailSrc="https://img.youtube.com/vi/m49xicAem6E/maxresdefault.jpg"
            thumbnailAlt="Hero Video"
          />
        </div>




      {studentId ? (
        <div>
        {yourCourses.length != 0 ? (
        <div className="container mx-auto p-4">
          <h1 className="text-2xl md:text-3xl text-center font-bold text-gray-900">Courses for YOU</h1>
          <p className="text-sm text-center">Explore NAE batches of your interest</p>
          <CourseList courses={yourCourses} />
        </div>
        ) : (<></>)}
        {yourCollectiveCourses.length != 0 ? (
        <div className="container mx-auto p-4">
          <h1 className="text-2xl md:text-3xl text-center font-bold text-gray-900">Collective Courses for YOU</h1>
          <CollectiveCourseList courses={yourCollectiveCourses} />
        </div>
        ) : (<></>)}
        </div>
      ) : (<></>)}

      
      
      {/* <NotificationsPage /> */}
      {/* {collectiveCourses.length != 0 ? (
      <div className="container mx-auto p-4">
        <h1 className="text-2xl md:text-3xl text-center font-bold text-gray-900">Explore Collective Courses</h1>
        <CollectiveCourseList courses={collectiveCourses} />
      </div>
      ):(<></>)} */}

      <Language4Ad />

      <div className="container mx-auto p-4 flex flex-col md:flex-row-reverse justify-center items-center">
        <div className="container mx-auto p-4 flex flex-col justify-center items-center">
          <h1 className="text-3xl md:text-5xl text-center font-bold text-gray-900">We do not Promise; </h1>
          <h1 className="text-center text-3xl md:text-5xl font-bold">We have <span className='text-red-500'>Plans!</span></h1>
        </div>
        <img
          src='assets/DanishSir.png'
          className="object-fit w-auto max-h-96"
          alt="Danish Sir"
        />
        
      </div>
      {/* <div className="container mx-auto p-4">
        <h1 className="text-2xl md:text-3xl text-center font-bold text-gray-900">Explore by Exam</h1>
        <p className="text-sm text-center">Explore NAE batches by your exam category</p>
        <ExploreByExam />
      </div> */}



      <FloatingWhatsAppButton
        phoneNumber="+917979061569"  // Replace with your WhatsApp number
        message="Hello! I'd like to ask some queries."  // Optional custom message
        tooltipText="Chat with us on WhatsApp"  // Optional custom tooltip
      />


    </div>
  );
};

export default Home;
